// extracted by mini-css-extract-plugin
export default {"container":"SafetySection_container__ZZqUO","title":"SafetySection_title__J8NML","list":"SafetySection_list__Fksd9"};